// extracted by mini-css-extract-plugin
export default {"actions":"forget-modal-finance_actions__7bBYG"};